import { SectionTitle } from "../components/SectionTitle";
import { SectionContainer } from "../components/SectionContainer";
import { MenuTab } from "../components/MenuTab";
import { Project, ProjectTypes } from "../types";
import { useState } from "react";
import { Card } from "../components/Card";
import { Link } from "react-router-dom";
import { useProjects } from "../hooks/useProjects";

const MobileDev = () => {
  return (
    <div className="px-2 py-2 text-center md:text-xl">
      <div className="flex justify-center h-28 md:h-40 my-8">
        <img
          src="/assets/images/MLG.png"
          className="bg-white rounded-md p-0.5"
        />
      </div>
      <div className="flex justify-center h-20">
        <a
          href="https://apps.apple.com/us/app/memory-lane-games/id1517193093"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img className="p-2 h-16 md:h-16" src="/assets/images/apple.svg" />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.memorylanegames.memorylanegameslite&hl=en&gl=US"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="p-2 h-16 md:h-16"
            src="/assets/images/google-play-badge.png"
          />
        </a>
      </div>
      <h2>
        In my role as Software Engineer at Memory Lane Games, I had the pleasure
        of working within a talented development team using an exciting tech
        stack in MERN. Using MongoDB, Express.js, React and Node.js, we built a
        responsive, native Dementia Therapy App and support tooling such as a
        user facing admin panel and an extensive content management system, that
        accumulated over one hundred thousand downloads across platforms.
      </h2>
    </div>
  );
};

export const Projects = () => {
  const [currentProject, setCurrentProject] = useState<ProjectTypes>("game");
  const [displayedProject, setDisplayedProject] =
    useState<ProjectTypes>("game");
  const [isFading, setIsFading] = useState(false);
  const { projects } = useProjects(displayedProject);

  // Handles tab switching with fade effect
  const handleTabChange = (type: ProjectTypes) => {
    if (type === displayedProject) return;
    setIsFading(true);
    setTimeout(() => {
      setDisplayedProject(type);
      setIsFading(false);
    }, 250);
    setCurrentProject(type);
  };

  return (
    <SectionContainer>
      <div className="flex w-full justify-center my-8">
        <div className="flex flex-wrap justify-center sm:justify-between w-full md:w-3/4 lg:w-2/6 gap-2 sm:gap-4 px-2">
          <MenuTab
            header={"Web"}
            onClick={handleTabChange}
            currentTab={currentProject}
          />
          <MenuTab
            header={"App"}
            onClick={handleTabChange}
            currentTab={currentProject}
          />
          <MenuTab
            header={"Game"}
            onClick={handleTabChange}
            currentTab={currentProject}
          />
          <MenuTab
            header={"Graphics"}
            onClick={handleTabChange}
            currentTab={currentProject}
          />
        </div>
      </div>
      <div>
        <div
          className={`transition-opacity duration-300 ${
            isFading ? "opacity-0" : "opacity-100"
          } ${
            displayedProject === "app"
              ? ""
              : "grid grid-cols-1 md:grid-cols-3 gap-8 p-2"
          }`}
        >
          {displayedProject === "app" ? (
            <MobileDev />
          ) : (
            projects &&
            projects.map((section: Project) => (
              <Link
                to={`/showcase/${displayedProject}/${section.id}`}
                key={`${displayedProject}-${section.id}`}
              >
                <Card
                  title={section.title}
                  content={section.content}
                  image={section.image}
                />
              </Link>
            ))
          )}
        </div>
      </div>
    </SectionContainer>
  );
};
